import React from 'react';
import LiveEventListItem from '../../containers/EventListItemContainers/LiveEventListItem';
import PreEventListItem from '../../containers/EventListItemContainers/PreEventListItem';
import VindespilEventListItem from '../../containers/EventListItemContainers/VindespilEventListItem';

const ViewEventListItemNew = ({ event: ev, header, userId }) => {
    if (!ev) {
        return null;
    }

    const isPrePage = () => window.location.pathname === '/sport/pre';

    const filterMarket = (market) => {
        const upperCaseName = market.marketName?.toUpperCase();
        const upperCaseGroupName = market.marketTypeGroupName?.toUpperCase();

        return (
            upperCaseName === '1X2' ||
            ev.defaultMarketId === market.marketId ||
            market.mainMarket === 1 ||
            upperCaseGroupName === '1X2'
        );
    };

    const marketList = ev?.marketList?.filter(filterMarket) ?? null;

    const isVinderSpil = marketList?.[0]?.marketTypeName?.includes(
        'Vinderspil'
    );
    const isH2H = marketList?.[0]?.marketTypeName?.includes('H2H');

    const getView = () => {
        if (ev.homeTeam && ev.homeTeam !== 'N/A' && !isVinderSpil && !isH2H) {
            if (ev.live) {
                return (
                    <LiveEventListItem
                        ev={ev}
                        marketList={marketList}
                        header={header}
                        userId={userId}
                    />
                );
            } else {
                return (
                    <PreEventListItem
                        ev={ev}
                        marketList={marketList}
                        header={header}
                        userId={userId}
                    />
                );
            }
        } else {
            if (!isPrePage()) {
                return (
                    <VindespilEventListItem
                        ev={ev}
                        marketList={marketList}
                        userId={userId}
                    />
                );
            }
        }
    };

    return getView();
};

export default ViewEventListItemNew;
